import React from "react";

const FormWarning = ({ text }) => {
  if (!text) return text;

  return <span className="dark-teal form-warn">{text}</span>;
};

export default FormWarning;
